import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { SOCIAL_AD_TYPES } from "utils/constants";
import { PAC_TYPE_LABELS } from "social/constants";

import TabSelector from "./TabSelector";
import PlacementSelector from "./PlacementSelector";
import { TABS } from "./Tabs";
import { facebookPreviewSelector, facebookPreviewAdTypes } from "selectors/Social2";

import "./FacebookSocialTabSelector.css";

const FlashtalkingFBTypes = [
	SOCIAL_AD_TYPES.FACEBOOK_IMAGE,
	SOCIAL_AD_TYPES.FACEBOOK_VIDEO,
	SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL,
];

export default function FacebookSocialTabSelector(props){
	const { adType } = props;
	const isFT = FlashtalkingFBTypes.includes(adType);
	const {
		pacType,
		selectedTab,
	} = useSelector(state => ({
		pacType: state.creativeDetails.socialValues?.placementAssetCustomizationType,
		selectedTab: state.social?.selectedTab,
	}));

	const previewOpts = useSelector(facebookPreviewSelector(adType));
	const tabOptions = useSelector(facebookPreviewAdTypes(adType));
	const disabledTabs = useMemo(() => (
		TABS.reduce((disabled, { value }) => {
			if(!tabOptions.includes(value) && value !== "generic") {
				disabled.push(value);
			}
			return disabled;
		}, [])
	), [tabOptions]);

	const isGenericPreview = selectedTab.value === "generic";
	const label = PAC_TYPE_LABELS[pacType] || "Placement";

	const shouldDisplaySelector = !isGenericPreview || (isGenericPreview && (!!pacType && pacType !== "none"));

	return (
		<div className="ft-social-tab-container facebook-preview-better">
			{isFT && <TabSelector disabledTabs={disabledTabs || []} tabs={TABS} className="platform-tabs" />}
			{shouldDisplaySelector && <PlacementSelector
				previewOpts = {previewOpts}
				label = {label}
			/>}
		</div>
	);
}

FacebookSocialTabSelector.displayName = "FacebookSocialTabSelector";
